import {qspost} from '@/plugins/axios'

/*
 * 添加/更新员工评价
 * @constructor jack
 * */
export const addAdminComment = (xiaoquId,adminId, type, content,id) => qspost('/Index/Datascreen/addAdminComment', {
  xiaoquId,adminId, type, content,id
})

/*
 * 员工评价列表
 * @constructor jack
 * */
export const getAdminCommentList = (xiaoQuId,adminId, searchTime, startTime,endTime,type,page,pageSize) => qspost('/Index/Datascreen/getAdminCommentList', {
  xiaoQuId,adminId, searchTime, startTime,endTime,type,page,pageSize
})

/*
 * 删除员工评价
 * @constructor jack
 * */
export const delAdminComment = (id) => qspost('/Index/Datascreen/delAdminComment', {  id})
